import { useState } from 'react';

export default apiFunc => {
  const [data, setData] = useState(null);
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);

  const request = async (...args) => {
    setLoading(true);
    try {
      const result = await apiFunc(...args);
      setData(result.data);
    } catch (err) {
      setError({
        message: err.message || 'Unexpected Error!',
        data: err?.response?.data
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    data,
    error,
    setLoading,
    loading,
    request
  };
};
